export const deviceWidths = {
  mobile: 1180,
  desktop: 3000,
};

export const deviceMaxWidths = {
  mobile: `(max-width: ${deviceWidths.mobile}px)`,
  desktop: `(max-width: ${deviceWidths.desktop}px)`,
};
